import { render, staticRenderFns } from "./Tdb.vue?vue&type=template&id=0d7d9795&scoped=true&"
import script from "./Tdb.vue?vue&type=script&lang=js&"
export * from "./Tdb.vue?vue&type=script&lang=js&"
import style0 from "./Tdb.vue?vue&type=style&index=0&id=0d7d9795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7d9795",
  null
  
)

export default component.exports